import { render } from "./PrestaShopLogoIcon.vue?vue&type=template&id=1ace08a8"
import script from "./PrestaShopLogoIcon.vue?vue&type=script&lang=js"
export * from "./PrestaShopLogoIcon.vue?vue&type=script&lang=js"

import "./PrestaShopLogoIcon.vue?vue&type=style&index=0&id=1ace08a8&lang=scss"

import exportComponent from "/home/runner/work/flydata-next/flydata-next/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__